export function createActionName(reducerName, actionName) {
    return `edf/${reducerName}/${actionName}`;
}
